import get from "lodash/get";
import assign from "lodash/assign";
import entries from "lodash/entries";
var BeeResponseModel = /** @class */ (function () {
    function BeeResponseModel(modelManager, model) {
        this.modelManager = modelManager;
        assign(this, model);
        if (this.response_type) {
            entries(this.body).forEach(function (_a) {
                var modelType = _a[0], response = _a[1];
                modelManager.constructModel(response, modelType);
            });
        }
    }
    BeeResponseModel.prototype.getData = function () {
        return this.body;
    };
    BeeResponseModel.prototype.get = function (key) {
        return get(this.body, key);
    };
    return BeeResponseModel;
}());
export { BeeResponseModel };
